export { default } from './CapacityBox'
